import React, { useState, useEffect, createRef, useImperativeHandle, useRef } from 'react';

import register from 'assets/register.png';
import Button from 'components/Button';
import PropTypes from 'prop-types';

import { Container, Title, Message, Actions, ProtectArea, WhatsAppCommunityMessage } from './styles';

const modalRef = createRef();

export function confirmModal(message, title, dense = false, size = 'small', okButton = 'OK', cancelButton = undefined, containerBackgroundColor = '#ffffff', largeButton = false, whatsAppCommunityMessage = false, program = "cnhpop") {
  return new Promise((resolve) => {
    if (modalRef && modalRef.current && modalRef.current.show) {
      modalRef.current.show(message, title, dense, size, { resolve }, okButton, cancelButton, containerBackgroundColor, largeButton, whatsAppCommunityMessage, program);
    }
  });
}

export default function ConfirmModal({ program }) {
  const [open, setOpen] = useState(false);
  const [dense, setDense] = useState(false);
  const [size, setSize] = useState('small');
  const [title, setTitle] = useState();
  const [message, setMessage] = useState();
  const [callback, setCallback] = useState();
  const [okButton, setOkButton] = useState();
  const [cancelButton, setCancelButton] = useState();
  const [containerBackgroundColor, setContainerBackgroundColor] = useState();
  const [largeButton, setLargeButton] = useState();
  const [whatsAppCommunityMessage, setWhatsAppCommunityMessage] = useState();
  const [selectedProgram, setSelectedProgram] = useState();

  const outsideRef = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (outsideRef.current && outsideRef.current.contains(event.target)) {
        setOpen(false);
        callback.resolve(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [outsideRef, callback]);

  useImperativeHandle(modalRef, () => ({
    show(messageParam, titleParam, denseParam, sizeParam, callbackParam, okParam, cancelParam, containerBackgroundColorParam, largeButton, whatsAppCommunityMessage, programParam) {
      setOpen(true);
      setDense(denseParam);
      setSize(sizeParam);
      setTitle(titleParam);
      setMessage(messageParam);
      setCallback(callbackParam);
      setOkButton(okParam);
      setCancelButton(cancelParam);
      setContainerBackgroundColor(containerBackgroundColorParam);
      setLargeButton(largeButton);
      setWhatsAppCommunityMessage(whatsAppCommunityMessage);
      setSelectedProgram(programParam)
    }
  }));

  return open && <>
    <ProtectArea ref={outsideRef} />
    <Container ref={modalRef} program={program} open={open} size={size} containerBackgroundColor={containerBackgroundColor}>
      <Title program={selectedProgram ?? program}>
        {title || (<img src={register} alt="CNH POP" />)}
      </Title>
      {whatsAppCommunityMessage ?
        <WhatsAppCommunityMessage>
          <h1>Você será direcionado para a nossa comunidade exclusiva no WhatsApp. <b><u>ENTRE NA COMUNIDADE</u> para receber todas as informações e atualizações do POP em sua cidade!</b></h1>
        </WhatsAppCommunityMessage> : <></>}
      <Message dense={dense}>
        {message}
      </Message >
      <Actions>
        {cancelButton && <Button
          label={cancelButton}
          program={program}
          onClick={() => { setOpen(false); callback.resolve(false); }}
        />}
        <Button
          label={okButton || 'OK'}
          program={selectedProgram ?? program}
          onClick={() => { setOpen(false); callback.resolve(true); }}
          largeButton={largeButton}
        />
      </Actions>
    </Container>
  </>;
}

ConfirmModal.propTypes = {
  program: PropTypes.string,
};

ConfirmModal.defaultProps = {
  program: 'cnhpop',
};
